export var isAppConsentedLocally = function isAppConsentedLocally(appId, accountId) {
  var _window$__consentedAp;
  return !!((_window$__consentedAp = window['__consentedApps']) !== null && _window$__consentedAp !== void 0 && _window$__consentedAp["".concat(appId, ":").concat(accountId)]);
};
export var setAppConsentLocal = function setAppConsentLocal(appId, accountId) {
  window.__consentedApps = window.__consentedApps || {};
  window.__consentedApps["".concat(appId, ":").concat(accountId)] = true;
};